<template>
  <!-- eslint-disable max-len -->
  <main class="bg-white u-container">
    <p class="mb-4">
      The Change-of-Address application has experienced an error and your request could not be processed.
    </p>
    <button
      ref="exit"
      class="c-btn--secondary mr-5 mb-5 sm:mb-0 m:mb-0 lg:mb-0 xl:mg-0"
      @click="reboot"
    >
      Exit
    </button>
    <router-link
      ref="editAddress"
      :to="editRoute"
      class="c-btn"
    >
      Edit Address
    </router-link>
  </main>
</template>

<script>
import { isDesktop } from '../utils/deviceType';
import pageView from '../mixins/pageView';

export default {
  name: 'ErrorFatalError',
  mixins: [pageView],
  computed: {
    editRoute() {
      return { name: !isDesktop() ? 'move-combined' : 'disclaimer' };
    },
  },
  mounted() {
    this.pageView();
  },
  methods: {
    reboot() {
      this.$deleteSession();
      this.$coa.reset();
      this.$router.replace({ name: 'disclaimer' });
    },
  },
};
</script>
